import { formatRupeeLabel } from '../../../../display-values/lumpsumPlanAmount'
import BottomSheetContent from '../../../../../../../components/BottomSheetComponents/BottomSheetContent'
import { convertEpochToDate } from '../../../../../../../utils/utils'
import {
  isMissedGainsComparisonAvailable,
  MissedGainsComparisonBarGraph,
  MissedGainsInfoUnavailableState
} from '../../../plans-list/header/rebalance/MissedGainsComparisonBarGraph'

export type FundMissedGainsInfoParams = {
  missedGains: number
  currentValue: number
  planSnapshotDate?: number | null
}

type FundMissedGainsInfoBottomSheetProps = FundMissedGainsInfoParams & {
  onDismiss: () => void
}

export function FundMissedGainsInfoBottomSheet({
  onDismiss,
  missedGains,
  currentValue,
  planSnapshotDate
}: FundMissedGainsInfoBottomSheetProps) {
  const isComparisonAvailable = isMissedGainsComparisonAvailable({
    missedGains,
    baselineValue: currentValue
  })
  const heading =
    (missedGains ?? 0) > 0
      ? `${formatRupeeLabel({ rawAmount: missedGains })} missed gains`
      : 'Missed gains'

  return (
    <BottomSheetContent
      heading={heading}
      onDismiss={onDismiss}
      bottomSheetHeadClassName="!pt-8"
      bottomSheetHeadingClassName="!text-[22px] !text-[#232323] !leading-[130%] !font-[500] !mb-0"
      bottomSheetBodyClassName="!pt-4 !pb-0"
      bottomSheetCtaClassName="!pt-5"
    >
      {isComparisonAvailable ? (
        <>
          <div className="text-[14px] font-[400] leading-[150%] text-[#6A6E6E]">
            {'This means your investment could have earned '}
            <span className="font-[500] text-[#6A6E6E]">
              {formatRupeeLabel({ rawAmount: missedGains })}
              {' more'}
            </span>
            {', had you followed our recommendation. '}
            {planSnapshotDate != null ? (
              <span className="font-[500] text-[#232323]">
                {`Calculated as of ${convertEpochToDate(planSnapshotDate, '%_d %b %Y')}.`}
              </span>
            ) : null}
          </div>
          <div className="mt-6 h-64 w-full rounded-[12px] border border-[#F0F4F7] px-2 pt-4">
            <MissedGainsComparisonBarGraph
              regularValue={currentValue}
              directValue={currentValue + missedGains}
              currentBarLabel="Current"
              switchBarLabel="Recommendation"
            />
          </div>
        </>
      ) : (
        <MissedGainsInfoUnavailableState />
      )}
    </BottomSheetContent>
  )
}
